import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export default function LanguageSetter() {
    const { i18n } = useTranslation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const lang = searchParams.get("lang");
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [searchParams, i18n]);

    return null;
}
